// totalCountが１０で、１ページに表示する件数が３０の場合、などを計算する
export const calcTotalPage = (totalCount: number, perPage: number) => {
  const totalPage = Math.ceil(totalCount / perPage);
  return totalPage;
};
